
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cmsPage]",
      function () {
        return require("private-next-pages/[cmsPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[cmsPage]"])
      });
    }
  